/**
 * manageSysManageSyncSignModule 端网自动同签管理
 * author: Qian.qianchen 2019-10-15
 */
"use strict";
angular.module('manageSysManageSyncSignModule', [
        'manageSysManageEditSyncSignModule'
    ])
    .controller('manageSysManageSyncSignCtrl', ['$scope', 'trsHttpService', 'modalDialog', '$q', '$state', 'trsspliceString', function($scope, trsHttpService, modalDialog, $q, $state, trsspliceString) {

        initStatus();
        initData();

        /**
         * [initStatus description] 状态初始化
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {

            };
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
                PAGECOUNT: 0,
                ITEMCOUNT: 0
            }
            $scope.data = {
                keywords: "",
                selectedArray: [],
                items: []
            }
        }

        /**
         * [initData description] 数据初始化
         * @return {[type]} [description]
         */
        function initData() {
            requestData();
        }

        function requestData() {
            let defer = $q.defer();
            let params = {
                serviceid: 'mlf_publishinsametime',
                methodname: 'queryPublishChannelRels',
                RelName: $scope.data.keywords,
                PageSize: $scope.page.PAGESIZE,
                CurrPage: $scope.page.CURRPAGE
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then((data) => {
                $scope.data.items = data.DATA;
                $scope.page = data.PAGER;
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [editSyncSign 修改/编辑]
         * @return {[type]} [description]
         */
        $scope.editSyncSign = function(item) {
            if (angular.isDefined(item)) {
                $state.go('manageconfig.sysmanage.syncsign.editsyncsign', { relid: item.PUBLISHCHANNELRELID });
            } else {
                $state.go('manageconfig.sysmanage.syncsign.editsyncsign');
            }
        };

        /**
         * [singleSelect 单选]
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.singleSelect = function(item) {
            var n = $scope.data.selectedArray.indexOf(item);
            n > -1 ? $scope.data.selectedArray.splice(n, 1) : $scope.data.selectedArray.push(item);
        };

        /**
         * [modifyStatus 修改状态]
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.modifyStatus = function(item) {
            modalDialog.alertType(item.RELSTATUS == 0 ? '确定停用' : '确定开启', '', 'ask', true, function() {
                var params = {
                    serviceid: 'mlf_publishinsametime',
                    methodname: 'changeStatus',
                    PublishChannelRelId: item.PUBLISHCHANNELRELID,
                    RelStatus: item.RELSTATUS == 0 ? -1 : 0
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    modalDialog.alertType(data.DETAIL, '', data.ISSUCCESS == 'true' ? 'success' : 'error', false, function() {
                        requestData();
                    });
                });
            });
        };

        /**
         * [deleteConfig 删除配置]
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.deleteConfig = function(item) {
            if (angular.isDefined(item) && item.RELSTATUS == 0) {
                modalDialog.alertType('启用中的配置无法删除，请先停用', '', 'info', 'confirm')
                return;
            }
            if (hasEnabled()) {
                modalDialog.alertType('启用中的配置无法删除，请先停用', '', 'info', 'confirm')
                return;
            }
            modalDialog.alertType('是否删除选中配置', '', 'ask', true, function() {
                var params = {
                    serviceid: 'mlf_publishinsametime',
                    methodname: 'deletePublishChannelRels',
                    PublishChannelRelIds: angular.isDefined(item) ? item.PUBLISHCHANNELRELID : trsspliceString.spliceString($scope.data.selectedArray, 'PUBLISHCHANNELRELID', ','),
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    modalDialog.multiReportsAlert(data, function() {
                        requestData();
                    });
                });
            });
        };

        /**
         * [hasEnabled 是否包含开启状态]
         * @return {Boolean} [description]
         */
        function hasEnabled() {
            var flag = $scope.data.selectedArray.some(function(item) {
                return item.RELSTATUS == 0;
            });
            return flag;
        }

        /**
         * [querySearchByKeyword 检索]
         * @param  {[type]} e [description]
         * @return {[type]}   [description]
         */
        $scope.querySearchByKeyword = function(e) {
            if (angular.isDefined(e.keyCode) && e.keyCode == 13 || angular.isUndefined(e.keyCode)) {
                requestData();
            }
        };
    }]);